import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function TokenomicsPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      setIsScrolled(window.scrollY > 50);
    });
  }

  const tokenData = [
    { label: '総発行枚数', value: '10億枚', icon: 'ri-coins-line', color: 'from-pink-500 to-rose-500' },
    { label: '初期流通枚数', value: '2億枚', icon: 'ri-exchange-line', color: 'from-purple-500 to-pink-500' },
    { label: 'ロック推奨期間', value: '長期保有', icon: 'ri-lock-2-line', color: 'from-rose-500 to-orange-500' },
    { label: 'リワード配布', value: '定期的', icon: 'ri-gift-line', color: 'from-pink-500 to-purple-500' },
  ];

  const lockingBenefits = [
    {
      title: 'ロックすることで得られるもの',
      items: [
        '定期的なリワード（報酬）',
        'ネットワークの安定化に貢献',
        '長期的な価値向上の可能性',
        'コミュニティへの参加権'
      ],
      icon: 'ri-gift-2-line'
    },
    {
      title: 'ロックの仕組み',
      items: [
        'トークンを一定期間預ける',
        'その間は売却できない',
        '代わりにリワードを受け取れる',
        '期間終了後は自由に使える'
      ],
      icon: 'ri-lock-unlock-line'
    }
  ];

  const nodeStructure = [
    {
      level: 'ノードオーナー',
      description: 'MAWARIネットワークを支える重要な役割',
      role: 'ネットワークの運営・維持',
      reward: 'リワード受取',
      color: 'bg-gradient-to-br from-pink-500 to-rose-500'
    },
    {
      level: 'トークンホルダー',
      description: 'トークンを保有し、ロックすることで参加',
      role: 'ネットワークの安定化',
      reward: 'ロックリワード',
      color: 'bg-gradient-to-br from-purple-500 to-pink-500'
    },
    {
      level: 'コミュニティ',
      description: '情報共有・サポート・学び合い',
      role: '初心者支援・知識共有',
      reward: '安心感・仲間',
      color: 'bg-gradient-to-br from-rose-500 to-orange-500'
    }
  ];

  const longTermThinking = [
    {
      period: '短期（数ヶ月）',
      focus: '基礎知識の習得',
      action: 'ロッキングの理解・実践',
      icon: 'ri-seedling-line'
    },
    {
      period: '中期（1〜2年）',
      focus: 'ネットワーク成長',
      action: 'リワード受取・再ロック',
      icon: 'ri-plant-line'
    },
    {
      period: '長期（3年以上）',
      focus: 'エコシステム拡大',
      action: 'コミュニティ貢献',
      icon: 'ri-tree-line'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 via-white to-rose-50">
      <Navbar isScrolled={isScrolled} />

      <main className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          {/* パンくずリスト */}
          <nav className="mb-8 text-base">
            <ol className="flex items-center space-x-2 text-gray-600">
              <li>
                <a href="/" className="hover:text-pink-600 transition-colors cursor-pointer">
                  TOP
                </a>
              </li>
              <li>
                <i className="ri-arrow-right-s-line"></i>
              </li>
              <li className="text-pink-600 font-semibold">トークノミクス</li>
            </ol>
          </nav>

          {/* ページタイトル */}
          <div className="text-center mb-16">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              トークノミクス
            </h1>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
              MAWARIトークンの仕組みと、長期的な視点での考え方を初心者の方にもわかりやすく解説します。
            </p>
          </div>

          {/* 重要な注意書き */}
          <div className="mb-16 bg-gradient-to-r from-amber-50 to-orange-50 border-l-4 border-orange-500 rounded-lg p-8 shadow-md">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-full flex-shrink-0">
                <i className="ri-alert-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">重要なお知らせ</h3>
                <p className="text-lg text-gray-800 leading-relaxed">
                  このページの内容は、投資助言や金融商品の勧誘を目的としたものではありません。暗号通貨への投資は、ご自身の判断と責任において行ってください。価格変動リスクがあることをご理解の上、余裕資金での参加をお勧めします。
                </p>
              </div>
            </div>
          </div>

          {/* トークン基本情報 */}
          <section className="mb-20">
            <h2 className="text-4xl font-bold text-gray-900 mb-10 text-center">
              トークン基本情報
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {tokenData.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
                >
                  <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${item.color} rounded-2xl mb-6 mx-auto`}>
                    <i className={`${item.icon} text-3xl text-white`}></i>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-700 mb-3 text-center">
                    {item.label}
                  </h3>
                  <p className="text-3xl font-bold text-gray-900 text-center">
                    {item.value}
                  </p>
                </div>
              ))}
            </div>
          </section>

          {/* ロックの仕組み */}
          <section className="mb-20">
            <h2 className="text-4xl font-bold text-gray-900 mb-10 text-center">
              ロックの仕組み
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {lockingBenefits.map((benefit, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-10 shadow-lg border border-gray-100"
                >
                  <div className="flex items-center mb-6">
                    <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-pink-500 to-rose-500 rounded-xl mr-4">
                      <i className={`${benefit.icon} text-2xl text-white`}></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">
                      {benefit.title}
                    </h3>
                  </div>
                  <ul className="space-y-4">
                    {benefit.items.map((item, idx) => (
                      <li key={idx} className="flex items-start">
                        <div className="w-8 h-8 flex items-center justify-center bg-pink-100 rounded-full mr-4 flex-shrink-0 mt-1">
                          <i className="ri-check-line text-lg text-pink-600"></i>
                        </div>
                        <span className="text-lg text-gray-700 leading-relaxed">
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            {/* ロックの流れ図解 */}
            <div className="mt-12 bg-gradient-to-br from-pink-50 to-rose-50 rounded-2xl p-10 border border-pink-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
                ロックの流れ（イメージ図）
              </h3>
              <div className="flex flex-col lg:flex-row items-center justify-between space-y-6 lg:space-y-0 lg:space-x-6">
                <div className="flex-1 bg-white rounded-xl p-6 shadow-md text-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full mx-auto mb-4">
                    <i className="ri-wallet-3-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">①トークン保有</h4>
                  <p className="text-base text-gray-600">ウォレットにトークンを保管</p>
                </div>

                <div className="w-12 h-12 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-3xl text-pink-500 hidden lg:block"></i>
                  <i className="ri-arrow-down-line text-3xl text-pink-500 lg:hidden"></i>
                </div>

                <div className="flex-1 bg-white rounded-xl p-6 shadow-md text-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-pink-500 to-rose-500 rounded-full mx-auto mb-4">
                    <i className="ri-lock-2-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">②ロック実行</h4>
                  <p className="text-base text-gray-600">一定期間トークンを預ける</p>
                </div>

                <div className="w-12 h-12 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-3xl text-pink-500 hidden lg:block"></i>
                  <i className="ri-arrow-down-line text-3xl text-pink-500 lg:hidden"></i>
                </div>

                <div className="flex-1 bg-white rounded-xl p-6 shadow-md text-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-purple-500 to-pink-500 rounded-full mx-auto mb-4">
                    <i className="ri-gift-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">③リワード受取</h4>
                  <p className="text-base text-gray-600">定期的に報酬を獲得</p>
                </div>
              </div>
            </div>
          </section>

          {/* ノード構造 */}
          <section className="mb-20">
            <h2 className="text-4xl font-bold text-gray-900 mb-10 text-center">
              ノード構造
            </h2>
            <p className="text-xl text-gray-700 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
              MAWARIネットワークは、3つの層で構成されています。それぞれが重要な役割を担い、支え合っています。
            </p>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {nodeStructure.map((node, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
                >
                  <div className={`${node.color} p-8 text-white`}>
                    <div className="text-6xl font-bold mb-2 opacity-50">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                    <h3 className="text-2xl font-bold mb-3">{node.level}</h3>
                    <p className="text-lg opacity-90">{node.description}</p>
                  </div>
                  <div className="p-8">
                    <div className="mb-6">
                      <h4 className="text-lg font-bold text-gray-900 mb-2 flex items-center">
                        <i className="ri-user-star-line text-xl text-pink-600 mr-2"></i>
                        役割
                      </h4>
                      <p className="text-base text-gray-700 leading-relaxed">
                        {node.role}
                      </p>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-gray-900 mb-2 flex items-center">
                        <i className="ri-gift-line text-xl text-pink-600 mr-2"></i>
                        得られるもの
                      </h4>
                      <p className="text-base text-gray-700 leading-relaxed">
                        {node.reward}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* 長期視点の考え方 */}
          <section className="mb-20">
            <h2 className="text-4xl font-bold text-gray-900 mb-10 text-center">
              長期視点の考え方
            </h2>
            <p className="text-xl text-gray-700 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
              暗号通貨は短期的な価格変動に一喜一憂するのではなく、長期的な視点で成長を見守ることが大切です。
            </p>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
              {longTermThinking.map((phase, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300"
                >
                  <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-pink-500 to-rose-500 rounded-2xl mb-6 mx-auto">
                    <i className={`${phase.icon} text-4xl text-white`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                    {phase.period}
                  </h3>
                  <div className="space-y-4">
                    <div>
                      <h4 className="text-lg font-semibold text-pink-600 mb-2">フォーカス</h4>
                      <p className="text-base text-gray-700">{phase.focus}</p>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-pink-600 mb-2">アクション</h4>
                      <p className="text-base text-gray-700">{phase.action}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* 長期保有のメリット */}
            <div className="bg-gradient-to-br from-pink-500 to-rose-500 rounded-2xl p-10 text-white shadow-xl">
              <h3 className="text-3xl font-bold mb-6 text-center">
                長期保有のメリット
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl flex-shrink-0">
                    <i className="ri-line-chart-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold mb-2">価格変動に強い</h4>
                    <p className="text-base opacity-90 leading-relaxed">
                      短期的な価格変動に左右されず、落ち着いて保有できます。
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl flex-shrink-0">
                    <i className="ri-team-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold mb-2">コミュニティ参加</h4>
                    <p className="text-base opacity-90 leading-relaxed">
                      長期保有者同士で情報交換し、学び合えます。
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl flex-shrink-0">
                    <i className="ri-gift-2-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold mb-2">継続的なリワード</h4>
                    <p className="text-base opacity-90 leading-relaxed">
                      ロックを続けることで、定期的にリワードを受け取れます。
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl flex-shrink-0">
                    <i className="ri-heart-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold mb-2">安心感</h4>
                    <p className="text-base opacity-90 leading-relaxed">
                      焦らず、自分のペースで学び、成長できます。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* HIROからのメッセージ */}
          <section className="mb-20">
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-10 lg:p-12 border border-pink-200 shadow-lg">
              <div className="flex items-center justify-center mb-6">
                <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-pink-500 to-rose-500 rounded-full">
                  <i className="ri-user-heart-line text-4xl text-white"></i>
                </div>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center">
                HIROからのメッセージ
              </h3>
              <div className="max-w-3xl mx-auto text-lg text-gray-800 leading-relaxed space-y-4">
                <p>
                  トークノミクスと聞くと難しそうに感じるかもしれませんが、要は「みんなで支え合う仕組み」です。
                </p>
                <p>
                  ワインを熟成させるように、じっくりと時間をかけて育てていく。そんなイメージで、焦らず楽しんでいきましょう。
                </p>
                <p>
                  価格が上がった下がったで一喜一憂するのではなく、「このプロジェクトを応援したい」「仲間と一緒に成長したい」という気持ちが一番大切です。
                </p>
                <p className="font-semibold text-pink-600">
                  わからないことがあれば、いつでもコミュニティで聞いてくださいね。一緒に学んでいきましょう！
                </p>
              </div>
            </div>
          </section>

          {/* CTA */}
          <section className="text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
              さらに詳しく学びたい方へ
            </h2>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <a
                href="/locking"
                className="px-10 py-5 bg-gradient-to-r from-pink-500 to-rose-500 text-white text-lg rounded-full font-bold hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-lock-2-line mr-2"></i>
                ロッキングとは
              </a>
              <a
                href="/beginner"
                className="px-10 py-5 bg-white text-pink-600 text-lg rounded-full font-bold border-2 border-pink-500 hover:bg-pink-50 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line mr-2"></i>
                初心者講座
              </a>
              <a
                href="/community"
                className="px-10 py-5 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-lg rounded-full font-bold hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-team-line mr-2"></i>
                コミュニティ参加
              </a>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}